import { SidebarItem } from '@shared/sidebaritem';

export const sidebarItems: SidebarItem[] = [
	{
		label: 'Printers',
		icon: 'acies_template',
		path: 'print/administration',
		overlay: false,
		children: [],
		permission: 'print:PrinterGet',
		parents: ['Print'],
		forceTranslateKey: 'print.printers.label',
	},
	{
		label: 'Print testing',
		icon: 'acies_upload',
		path: 'print/test',
		overlay: false,
		children: [],
		// The page's actual action is submitting a test print job (POST /print/collections),
		// which is gated by print:LabelPost - not print:PrinterPost (which is printer CRUD,
		// an unrelated resource). PrinterGet-gated printer/template lookups already fail soft
		// (see PrintTestComponent), so this is the correct single gate for the page itself.
		permission: 'print:LabelPost',
		parents: ['Print'],
		forceTranslateKey: 'print.test.label',
	},
	{
		label: 'Print Collection Jobs',
		icon: 'acies_list',
		path: 'print/collection-jobs',
		overlay: false,
		children: [],
		permission: 'print:LabelListGet',
		parents: ['Print'],
		forceTranslateKey: 'print.collection-jobs.label',
	},
	{
		label: 'Print Jobs',
		icon: 'acies_list',
		path: 'print/jobs',
		overlay: false,
		children: [],
		permission: 'print:LabelExecutionList',
		parents: ['Print'],
		forceTranslateKey: 'print.jobs.label',
	},
];
